// import "./styles/formStyles.css";
import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "./assets/vendors/style";
import "./styles/wieldy.less";
import { PersistGate } from "redux-persist/integration/react";
import { message } from "antd";

import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import { AuthProvider } from "./authentication";
import { ScreenWidthProvider } from "./context/ScreenWidthContext";

export const { store, persistor } = configureStore();

// Configure Ant Design message to allow multiple messages
message.config({
  maxCount: 1, // Allow up to 5 messages at once
  duration: 4, // Messages will auto-close after 4 seconds
  top: 24, // Distance from top
  rtl: false, // Right-to-left support
});

const NextApp = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <AuthProvider>
          <ScreenWidthProvider>
            <Switch>
              <Route path="/" component={App} />
            </Switch>
          </ScreenWidthProvider>
        </AuthProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);

export default NextApp;
